'use strict';

var Notification = {};
var I18N = require('utils/i18n');

//auto hide notification
Notification.show = function (style, title, text, duration) {
    var icon = 'fa fa-adjust';

    if (style == 'error') {
        icon = 'fa fa-exclamation';
    } else if (style == 'warning') {
        icon = 'fa fa-warning';
    } else if (style == 'success') {
        icon = 'fa fa-check';
    } else if (style == 'info') {
        icon = 'fa fa-exclamation';
    } else {
        icon = 'fa fa-adjust';
    }

    $.notify(
        {
            title: title,
            text: text,
            image: '<i class="' + icon + '"></i>',
        },
        {
            style: 'metro',
            className: style,
            globalPosition: 'top center',
            showAnimation: 'show',
            showDuration: 0,
            hideDuration: 0,
            autoHideDelay: duration || 3000,
            autoHide: true,
            clickToHide: true,
        }
    );

    var windowWidth = document.body.clientWidth;
    var $notificationBox = $('.notifyjs-corner');

    if (windowWidth < 500) {
        $notificationBox.css('left', '0px');
        $notificationBox.css('width', '100%');
    } else {
        var leftPos = (windowWidth - $notificationBox.width()) / 2.0;
        $notificationBox.css('left', leftPos + 'px');
    }
};

Notification.error = function (msg) {
    Notification.show('error', I18N.TR('Fehler'), msg);
};

module.exports = Notification;
